import { Outlet } from "react-router-dom";
import VerticalNavigation from "../../Components/Layout/Navigation/VerticalNavigation";
import SettingsMenuItems from "../../Components/Layout/Navigation/MenuItems/SettingsMenuItems";
import React from "react";
import {useSelector} from "react-redux";

export default function SettingsLayout({ }) {
    const sideMenuOpen = useSelector((state) => state.CommonReducer.sideMenuOpen);
    return (
        <div className={`page-holder${!sideMenuOpen? 'hidden-vert-menu' : ''}`}>
            <VerticalNavigation>
                <SettingsMenuItems />
            </VerticalNavigation>
            <div className="container-fluid">
                <Outlet />
            </div>
        </div>
    );
}